import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFilterButtonBase"], {
        modelValue: $setup.menuIsVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.menuIsVisible) = $event)),
        "apply-button-text": $setup.applyButtonTextComputed,
        "reset-button-text": $setup.resetButtonTextComputed,
        "apply-filters": $setup.applyFilters,
        "on-reset-button-clicked": $setup.onResetButtonClicked,
        "reset-filter": $setup.resetFilter,
        "display-string": $setup.displayString,
        label: $props.label,
        id: $setup.returnFilterButtonId($props.id),
        "search-input-class": "bg-transparent"
    }, {
        label: _withCtx(() => [
            _createCommentVNode(" The filter button's label "),
            _renderSlot(_ctx.$slots, "default")
        ]),
        prefix: _withCtx(() => [
            _createVNode($setup["EnFilterButtonTypePrefix"], {
                "should-show-prefix": $setup.shouldShowPrefixComputed,
                type: $props.type
            }, null, 8 /* PROPS */, ["should-show-prefix", "type"])
        ]),
        default: _withCtx(() => [
            _createVNode($setup["EnDatePicker"], {
                modelValue: $setup.changedValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.changedValue) = $event)),
                modelModifiers: { trim: true },
                hint: $props.hint,
                id: $setup.returnId($props.id),
                "is-month": $props.isMonth,
                "allowed-dates": $props.allowedDates,
                "persistent-hint": ""
            }, null, 8 /* PROPS */, ["modelValue", "hint", "id", "is-month", "allowed-dates"]),
            _createElementVNode("div", null, [
                ($props.filterTypeSelectionVisible)
                    ? (_openBlock(), _createBlock($setup["EnFilterTypeSelectButton"], {
                        key: 0,
                        modelValue: $setup.selectedType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.selectedType) = $event)),
                        id: $setup.returnTypeId($props.id),
                        items: $setup.typeItemsNumber
                    }, null, 8 /* PROPS */, ["modelValue", "id", "items"]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "apply-button-text", "reset-button-text", "apply-filters", "on-reset-button-clicked", "reset-filter", "display-string", "label", "id"]));
}
